import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchRevenueProportion (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/aggregators/revenue/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

function fetchRevenueProportionByDelivery (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/aggregators/revenue/proportion/delivery`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

export default {
  fetchRevenueProportion,
  fetchRevenueProportionByDelivery,
}
